module.exports = __webpack_public_path__ + "static/media/part4.4c7cf9c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/partners/part4.png
// module id = 105
// module chunks = 0